/* eslint-disable no-console */
export default {
  data() {
    return {
      mediaRecorder: null,
      audioChunks: [],
      audioUrl: null,
      audioBlob: null,
      recording: false,
      interval: null,
      timeStamp: 0,
      audio: null,
      playing: false,
    };
  },
  methods: {
    async audioRecord(e) {
      this.audioChunks = [];
      const nav = await navigator.mediaDevices.getUserMedia({ audio: true });
      this.mediaRecorder = new MediaRecorder(nav);
      this.mediaRecorder.start();
      this.mediaRecorder.addEventListener("dataavailable", (event) => {
        this.audioChunks.push(event.data);
      });
      this.mediaRecorder.addEventListener("stop", () => {
        this.audioBlob = new Blob(this.audioChunks, { type: "audio/webm" });
        this.audioUrl = URL.createObjectURL(this.audioBlob);
        this.$emit("stop-recording");
        if (this.onStopRecording) {
          this.onStopRecording(e);
        }
      });
    },
    audioPlay() {
      if (this.audioUrl) {
        this.audio = new Audio(this.audioUrl);
        this.audio.onended = () => {
          this.playing = false;
        };
        this.audio.play();
        this.playing = true;
      }
    },
    audioNoPlay() {
      this.audio.pause();
      this.audio.currentTime = 0;
      this.playing = false;
    },
    audioStop() {
      this.mediaRecorder.stop();
    },
    onRecord(e) {
      try {
        if (!this.recording) {
          this.audioRecord(e);
          this.recording = true;
          this.timeStamp = 0;
          this.interval = setInterval(() => {
            this.timeStamp += 1;
          }, 1000);
        } else {
          clearInterval(this.interval);
          this.recording = false;
          this.audioStop();
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log("Error on Recording", error);
      }
    },
    removeAudio() {
      this.audioBlob = null;
      this.audioUrl = null;
      this.audioChunks = [];
      this.timeStamp = 0;
    },
    addZero(value) {
      if (value < 10) return "0" + String(Number.parseInt(value));
      else return String(Number.parseInt(value));
    },
    formatTime(value) {
      let minutes = Number.parseInt(value) / 60;
      let seconds = Number.parseInt(value) % 60;
      return this.addZero(minutes) + ":" + this.addZero(seconds);
    },
    uploadAudioFile() {
      let fileInput = document.createElement("input");
      fileInput.type = "file";
      fileInput.accept = "audio/*";
      fileInput.oninput = (e) => {
        this.audioUrl = URL.createObjectURL(e.target.files[0]);
        this.audioBlob = e.target.files[0];
        this.timeStamp = 0;
      };
      fileInput.click();
    },
  },
};
